import React, { useRef } from 'react';
import { SdfGrid, SdfSelect, SdfxPagination } from '@synerg/react-components';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';

const agGridKey = window.SynergConfig.getKey('ag-grid-enterprise');
LicenseManager.setLicenseKey(agGridKey);

export const AuthGrid = (props) => {
	const {
		cols, data, start, end, pageNo, pageSize, setSortOrder, setPageSize, setPageNo, totalPages,
		availablePageSizes
	} = props;

	const grid = useRef();

	const defaultColDef = {
		sortable: true,
		filter: false,
		resizable: false,
		wrapText: true,
		suppressMovable: true,
		suppressMenu: true
	};

	const gridOptions = {
		defaultColDef: defaultColDef,
		pagination: false,
		suppressPaginationPanel: true,
		paginationPageSize: 10,
		suppressHorizontalScroll: true
	};

	const myIcons = {
		first: "<sdf-icon icon='nav-page-first' />",
		previous: "<sdf-icon icon='nav-page-back' />",
		next: "<sdf-icon icon='nav-page-next' />",
		last: "<sdf-icon icon='nav-page-last' />",
		sortAscending: "<sdf-icon icon='action-sort-asc' />",
		sortDescending: "<sdf-icon icon='action-sort-desc' />",
		sortUnSort: "<sdf-icon icon='action-sort' />"
	};

	const onSortChanged = (params) => {
		let columnWithSort = params.columnApi.getColumnState().find(col => col.sort !== null);
		if (columnWithSort) {
			setSortOrder({ colId: columnWithSort.colId, sortBy: columnWithSort.sort });
		} else {
			setSortOrder({ colId: '', sortBy: '' });
		}
	};

	const columnDefs = cols.map((col, index) => ({
		field: col.field,
		headerName: col.headerName,
		sortable: col.sort,
		cellRenderer: col.cellRenderer,
		toolPanelClass: col.toolPanelClass,
		suppressMovable: true,
		flex: col.flex || 1,
		width: col.width || "auto",
		headerClass: col.textCenter ? "text-center" : "",
		cellStyle: { textAlign: col.textCenter ? "center" : "left" }
	}));

	return (
		<div className="w-full">
			<SdfGrid className={"w-full ag-theme-alpine grey-header"}>
				<AgGridReact
					ref={grid}
					rowHeight={52}
					headerHeight={52}
					domLayout="autoHeight"
					gridOptions={gridOptions}
					icons={myIcons}
					rowData={data}
					rowClass="template-row pt-1 cursor-pointer w-full"
					autoSizeAllColumns={true}
					unSortIcon={true}
					overlayNoRowsTemplate="No subscriptions found at this time"
					onSortChanged={onSortChanged}
					columnDefs={columnDefs}
				>

				</AgGridReact>
			</SdfGrid>
			{Array.isArray(data) && data.length > 0 && (
				<div className="flex items-center justify-end pt-4 pb-4">
					<div className="text-sm text-action-default">Rows per page:</div>
					<SdfSelect
						className="w-20 text-sm text-action-default px-4 mb-1 border-r-1 border-t-0 border-l-0 border-b-0 border-dark border-solid"
						label="rows per page"
                        hideLabel={true}
						items={availablePageSizes}
						onSdfChange={({ detail }) => {
							setPageSize(detail.value);
						}}
						value={{ label: `${pageSize}`, value: pageSize }}
					/>
					<div className="text-sm text-action-default px-4">{`${start} - ${end} items`}</div>
					{totalPages >= 1 && (
						<SdfxPagination
							currentPage={pageNo}
							totalPages={totalPages}
							onSdfxPageChange={({ detail }) => {
								setPageNo(detail);
							}}
						/>
					)}
				</div>
			)}
		</div>
	);
};
